import { z } from 'zod';

export const RoleSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  isActive: z.boolean(),
});

export type Role = z.infer<typeof RoleSchema>;

/** Request body schema for POST /roles — create a new role. */
export const CreateRoleBodySchema = z.object({
  name: z.string().min(1),
  code: z.string().min(1),
});
export type CreateRoleBody = z.infer<typeof CreateRoleBodySchema>;

/** Request body schema for PATCH /roles/:id — update an existing role. */
export const UpdateRoleBodySchema = z.object({
  name: z.string().min(1).optional(),
  isActive: z.boolean().optional(),
});
export type UpdateRoleBody = z.infer<typeof UpdateRoleBodySchema>;

/**
 * Coerces the URL query-string boolean form correctly:
 * - "true" / "1" -> true, anything else (e.g. "false", "") -> false, absent -> undefined.
 * - z.coerce.boolean() maps "false" (a non-empty string) to true, so we transform instead.
 */
const queryBoolean = z
  .string()
  .transform((v) => v === 'true' || v === '1')
  .or(z.boolean())
  .optional();

/**
 * Request query schema for GET /roles.
 * `includeInactive=true` includes deactivated roles (e.g. the permission-matrix
 * admin screen); omitted/false preserves the historical active-only default
 * relied on by user role-assignment dropdowns.
 */
export const GetRolesQuerySchema = z.object({
  includeInactive: queryBoolean,
});
export type GetRolesQuery = z.infer<typeof GetRolesQuerySchema>;

export const MediaFormatGroupSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
});

export type MediaFormatGroup = z.infer<typeof MediaFormatGroupSchema>;
